import { formatCurrency } from "./currency";

export interface WhatsAppCartItem {
  name: string;
  quantity: number;
  unitPrice: number;
  variant?: string | null;
}

export function whatsappPhone(phone: string): string | null {
  const digits = phone.replace(/\D/g, "");
  if (/^0[789]\d{9}$/.test(digits)) return `234${digits.slice(1)}`;
  if (/^[789]\d{9}$/.test(digits)) return `234${digits}`;
  if (/^234[789]\d{9}$/.test(digits)) return digits;
  return null;
}

export function formatWhatsAppOrder(storeName: string, items: WhatsAppCartItem[], reference: string): string {
  const lines = items.map(item =>
    `${item.quantity}x ${item.name}${item.variant ? ` (${item.variant})` : ""} - ${formatCurrency(item.unitPrice * item.quantity)}`,
  );
  const subtotal = items.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
  return [
    `Hello ${storeName}, I want to buy:`,
    ...lines,
    `Subtotal: ${formatCurrency(subtotal)}`,
    `Order Ref: #${reference}`,
    "Please confirm availability, delivery and the final total. This message is a request, not a placed or paid order.",
  ].join("\n");
}